import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplateEditorComponent } from './template-editor.component';

const routes: Routes = [
    { path: 'create', component: TemplateEditorComponent },
    { path: 'edit/:id', component: TemplateEditorComponent },
    { path: 'duplicate/:id', component: TemplateEditorComponent }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TemplateEditorRoutingModule {}
